// Hunger HUD (UI-4): 10 drumsticks (2 hunger each), full/half/empty. Hidden in
// creative/spectator. Sprite painted once (pixel-art, no assets). Client (ENG-1).
import { h } from '../h';
import { modeCaps } from '../../../sim/game/modes';
import type { Game } from '../../boot';

const SIZE = 9;

function foodURL(kind: number): string {
  const cvs = document.createElement('canvas');
  cvs.width = SIZE; cvs.height = SIZE;
  const ctx = cvs.getContext('2d')!;
  const mask = [
    '...##..',
    '..####.',
    '.####..',
    '######.',
    '.####..',
    '..###..',
    '..#....',
  ];
  const meat = kind === 0 ? '#2e2416' : '#b5722e';
  const bone = kind === 0 ? '#2e2416' : '#efe4c4';
  for (let y = 0; y < mask.length; y++) {
    for (let x = 0; x < mask[y]!.length; x++) {
      if (mask[y]![x] !== '#') continue;
      const half = kind === 1 && x < Math.floor(mask[y]!.length / 2);
      ctx.fillStyle = half ? '#2e2416' : y >= 5 ? bone : meat;
      ctx.fillRect(x + 1, y + 1, 1, 1);
    }
  }
  return cvs.toDataURL();
}

export class Hunger {
  readonly el: HTMLElement;
  private readonly cells: HTMLElement[] = [];
  private readonly kind: number[] = new Array(10).fill(-1);
  private readonly urls = [foodURL(0), foodURL(1), foodURL(2)];
  private lastShow: boolean | null = null;

  constructor() {
    this.el = h('div', { class: 'bb-hunger' });
    for (let i = 0; i < 10; i++) {
      const c = h('div', { class: 'bb-stat-icon' });
      this.cells.push(c);
      this.el.append(c);
    }
  }

  update(game: Game): void {
    const p = game.playerState;
    const show = modeCaps(p.gameMode).survivalHunger;
    if (show !== this.lastShow) { this.el.style.display = show ? 'flex' : 'none'; this.lastShow = show; }
    if (!show) return;
    const food = Math.max(0, Math.round(p.hunger));
    for (let slot = 0; slot < 10; slot++) {
      const v = food - slot * 2;
      const kind = v >= 2 ? 2 : v === 1 ? 1 : 0;
      if (kind === this.kind[slot]) continue;
      this.kind[slot] = kind;
      this.cells[slot]!.style.backgroundImage = `url(${this.urls[kind]})`;
    }
  }
}
